export default __webpack_public_path__ + "static/media/C-8.e904111e.png";